module.exports = __webpack_public_path__ + "static/media/address-book-regular.b2405257.svg";